export default __webpack_public_path__ + "static/media/LoadingGifV2.99985ec7.gif";